(() => {
  if (window.__ldCertificationDialogsReady) return;
  window.__ldCertificationDialogsReady = true;

  let returnFocus = null;
  const FOCUSABLE_SELECTOR = 'a[href],button:not([disabled]),input:not([type="hidden"]):not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';

  const getFocusableElements = (dialog) => Array.from(dialog.querySelectorAll(FOCUSABLE_SELECTOR))
    .filter((element) => element.getClientRects().length > 0 && window.getComputedStyle(element).visibility !== 'hidden');

  const trapDialogTab = (event) => {
    if (event.key !== 'Tab') return;
    const dialog = event.currentTarget;
    const focusable = getFocusableElements(dialog);
    if (!focusable.length) {
      event.preventDefault();
      dialog.focus({ preventScroll: true });
      return;
    }

    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    const active = document.activeElement;
    if (event.shiftKey && (active === first || !dialog.contains(active))) {
      event.preventDefault();
      last.focus({ preventScroll: true });
    } else if (!event.shiftKey && (active === last || !dialog.contains(active))) {
      event.preventDefault();
      first.focus({ preventScroll: true });
    }
  };

  const getDialog = (trigger) => {
    const id = trigger?.getAttribute('aria-controls');
    if (!id) return null;
    return document.getElementById(id);
  };

  const openDialog = (dialog, trigger) => {
    if (!dialog) return;
    returnFocus = trigger || document.activeElement;
    dialog.addEventListener('keydown', trapDialogTab);
    if (typeof dialog.showModal === 'function') dialog.showModal();
    else dialog.setAttribute('open', '');
    const close = dialog.querySelector('[data-ld-cert-close]');
    window.requestAnimationFrame(() => close?.focus({ preventScroll: true }));
  };

  const closeDialog = (dialog) => {
    if (!dialog) return;
    dialog.removeEventListener('keydown', trapDialogTab);
    if (typeof dialog.close === 'function') dialog.close();
    else dialog.removeAttribute('open');
    const focusTarget = returnFocus;
    if (focusTarget instanceof HTMLElement && focusTarget.isConnected) {
      window.requestAnimationFrame(() => {
        if (focusTarget.isConnected) focusTarget.focus({ preventScroll: true });
      });
    }
    returnFocus = null;
  };

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-ld-cert-open]');
    if (trigger) {
      event.preventDefault();
      openDialog(getDialog(trigger), trigger);
      return;
    }

    const close = event.target.closest('[data-ld-cert-close]');
    if (close) {
      closeDialog(close.closest('[data-ld-cert-dialog]'));
      return;
    }

    const dialog = event.target.closest('[data-ld-cert-dialog]');
    if (dialog && event.target === dialog) closeDialog(dialog);
  });

  document.addEventListener('cancel', (event) => {
    const dialog = event.target.closest?.('[data-ld-cert-dialog]');
    if (!dialog) return;
    event.preventDefault();
    closeDialog(dialog);
  }, true);
})();
